import React, { useState, useEffect } from 'react';
import superAdminService from '../../services/api/superAdminService';
// import axios from 'axios';
import './Autocomplete.css';
import { useHistory } from 'react-router-dom';
import {
  CircularProgress,
} from '@mui/material';
import Cookies from 'js-cookie';

const Autocomplete = () => {
  const [inputValue, setInputValue] = useState('');
  const [options, setOptions] = useState([]);
  const [filteredOptions, setFilteredOptions] = useState([]);
 const [loading, setLoading] = useState(false);
 const navigate = useHistory();
  // Search schools and MATs on input change (debounced)
  useEffect(() => {
    if (!inputValue || inputValue.length < 2) {
      setFilteredOptions([]);
      setLoading(false);
      return;
    }

    // Debounce search to avoid too many API calls
    const timeoutId = setTimeout(() => {
      setLoading(true);
      superAdminService
        .searchSchoolsAndMats(inputValue, 20)
        .then((response) => {
          if (response.success && response.data) {
            setFilteredOptions(response.data);
          } else {
            setFilteredOptions([]);
          }
          setLoading(false);
        })
        .catch((error) => {
          console.error('Error searching schools and MATs:', error);
          setFilteredOptions([]);
          setLoading(false);
        });
    }, 300); // 300ms debounce

    return () => {
      clearTimeout(timeoutId);
      setLoading(false);
    };
  }, [inputValue]);

  const handleInputChange = (event) => {  
    setInputValue(event.target.value);   
  };

  const handleOptionClick = (option) => {   
    setInputValue(option.Name);
    setFilteredOptions([]);
    // Use Type field from SearchResultDto to determine if it's a school or MAT
    if (option.Type === 1) { // SearchResultType.School
      handleSchoolDetails(option.Id);
    } else if (option.Type === 2) { // SearchResultType.Mat
      handleMatDetails(option.Id);
    } else {
      // Fallback: check name for "(Trust)" suffix
      const query = '(Trust)';
      if (!option.Name.toLowerCase().includes(query.toLowerCase())) {
        handleSchoolDetails(option.Id);
      } else {
        handleMatDetails(option.Id);
      }
    }
  };

   const handleSchoolDetails = (id) => {
      // Handle edit action
      console.log('School ID:', id);
      // Use query parameter for localhost compatibility (works on both localhost and production)
      navigate.push(`/school-detail?schoolId=${id}`);
      // Also set cookie for backward compatibility (without domain restriction for localhost)
      Cookies.set('SchoolDetailId', id, { expires: 1 });
      localStorage.setItem('SelectedSchoolId', id);
    };
  
     /* Welbee Grid Properties and function starts*/
     const handleMatDetails = (id) => {
      // Handle edit action
      console.log('MAT ID:', id);
      // Use query parameter for localhost compatibility (works on both localhost and production)
      navigate.push(`/group-detail?matId=${id}`);
      // Also set cookie for backward compatibility (without domain restriction for localhost)
      Cookies.set('MatDetailId', id, { expires: 1 });
    };

  return (
    <div className="autocomplete">
       <input
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        placeholder="Type to search School/Group..."
      />
    {loading===true? (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '0px' }}>
        <CircularProgress style={{width: '25px', height: '25px',  'margin-top': '-38px'}} />
        </div>  
    ) : (    
     filteredOptions.length > 0 && (
        <ul className="autocomplete-options">
          {filteredOptions.map(option => (
            <li key={option.Id} onClick={() => handleOptionClick(option)}>
              {option.Name}
            </li>
          ))}
        </ul>
      )
      )}   
  </div>
  );
};

export default Autocomplete;